export default {
  header: 300,
}
